import {ReservationAvailabilityStatus} from "../types/ReservationAvailabilityStatus";
import {ReservationCtaState} from "../types/ReservationCtaState";

interface IGetReservationCtaStateParams {
    isEligible: boolean;
    isReservedBySsr: boolean;
    status: ReservationAvailabilityStatus | undefined;
    hasData: boolean;
    isError: boolean;
}

/**
 * The first matching rule wins. "reserved" is checked before "pending" on purpose: the "reserved by me" marker
 * reports `status: "taken"` with `hasData: true` while the availability request may still be in flight,
 * so the button must not flash the placeholder before settling on "reserved".
 */
export const getReservationCtaState = (params: IGetReservationCtaStateParams): ReservationCtaState => {
    const {isEligible, isReservedBySsr, status, hasData, isError} = params;

    if (!isEligible) {
        return "hidden";
    }

    if (isReservedBySsr || status === "taken") {
        return "reserved";
    }

    if (!hasData && !isError) {
        return "pending";
    }

    if (isError || status !== "available") {
        // fail closed: request error, "unavailable", "not_mapped" or no entry for the property
        return "hidden";
    }

    return "active";
};
import {ReservationAvailabilityStatus} from "../types/ReservationAvailabilityStatus";
import {ReservationCtaState} from "../types/ReservationCtaState";

interface IGetReservationCtaStateParams {
    isEligible: boolean;
    isReservedBySsr: boolean;
    status: ReservationAvailabilityStatus | undefined;
    hasData: boolean;
    isError: boolean;
}

/**
 * The first matching rule wins. "reserved" is checked before "pending" on purpose: the "reserved by me" marker
 * reports `status: "taken"` with `hasData: true` while the availability request may still be in flight,
 * so the button must not flash the placeholder before settling on "reserved".
 */
export const getReservationCtaState = (params: IGetReservationCtaStateParams): ReservationCtaState => {
    const {isEligible, isReservedBySsr, status, hasData, isError} = params;

    if (!isEligible) {
        return "hidden";
    }

    if (isReservedBySsr || status === "taken") {
        return "reserved";
    }

    if (!hasData && !isError) {
        return "pending";
    }

    if (isError || status !== "available") {
        // fail closed: request error, "unavailable", "not_mapped" or no entry for the property
        return "hidden";
    }

    return "active";
};
